import styled, { css } from 'styled-components'
import colors from 'Assets/colors'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  addButton: {
    width: '100%',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    textAlign: 'center',
    textTransform: 'none',
    color: colors.white,
    transition: 'all 0.2s',
    backgroundColor: colors.secondary,
    marginTop: '20px',

    '&:hover': {
      opacity: 0.8,
      color: colors.white,
      transform: 'translateY(-2px)',
      backgroundColor: colors.secondary,
      boxShadow: '0 3px 5px rgba(51, 51, 51, 0.2)',
    },
    '&:active': {
      transform: 'translate(-1px)',
      boxShadow: '0 1px 3px rgba(51, 51, 51, 0.4)',
    },
  },
}))

export const MainContainer = styled.div`
  display: flex;
  flex: 1;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`

export const ButtonExtraServiceCart = styled.div`
  width: 100%;
  background-color: ${props => (props.hasAmount ? (props.focused ? '#f4f1f1' : colors.white) : colors.secondary)};
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: center;
  text-transform: none;
  color: ${props => (props.hasAmount ? colors.black : colors.white)};
  transition: all 0.2s;
  display: flex;
  justify-content: ${props => (props.hasAmount ? 'flex-end' : 'center')};
  align-items: center;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  border-radius: 0.5rem;
  cursor: ${props => (props.hasAmount ? null : 'pointer')};
  border: ${props => (props.hasAmount ? `2px solid ${colors.cart}` : null)};
  border: ${props => (props.error ? `2px solid ${colors.red}` : null)};
  height: 56px;
  margin: ${props => props.margin};

  &:hover {
    opacity: ${props => (props.hasAmount ? 1 : 0.8)};
    transform: ${props => (props.hasAmount ? null : 'translateY(-2px)')};
    box-shadow: ${props => (props.hasAmount ? null : '0 3px 5px rgba(51, 51, 51, 0.2)')};
  }

  &:active {
    transform: ${props => (props.hasAmount ? null : 'translate(-1px)')};
    box-shadow: ${props => (props.hasAmount ? null : '0 1px 3px rgba(51, 51, 51, 0.4)')};
  }

  .flag {
    background: ${colors.cart};
    color: ${colors.black};
    padding: 0 8px;
    border-radius: 8px;
    margin-left: 8px;
    line-height: 24px;
  }

  &.disabled {
    background-color: ${colors.gray40l};
    pointer-events: none;
  }
`

export const BoxContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  margin-bottom: 20px;
`

export const ImageNotList = styled.img`
  width: 80px;
  height: 80px;
`

export const ExtraServiceDesc = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
  padding-bottom: 10px;
  text-align: center;
`
export const ExtraServicePH = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;

  text-align: center;
`

export const ExtraServiceTitle = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding-bottom: 10px;
  margin-top: 16px;
  text-align: left;
  align-items: flex-start;
  color: ${props => props.theme.colors.black};
`

export const ExtraServiceInput = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding-bottom: 20px;
  color: #a3a3a3;
  background: #f3f3f3;
`

export const ExtraServiceContainer = styled.div`
  font-family: Inter;
  flex: 1;
  height: ${props => (props.isHorizontal ? 'inherit' : '140px')};
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: stretch;
  min-width: ${props => (props.isHorizontal && props.isExtraService ? '260px' : 'inherit')};
`
export const RowTB = styled.div`
  display: grid;
  grid-template-columns: 70% 30%;
  border: 1px solid #777777;
  border-radius: 8px;
  align-items: center;
  height: 50px;
  margin-top: 10px;
`

export const ESDesc = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.3;
  padding-left: 10px;
`

export const ESPrice = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  align-content: center;
  padding-right: 10px;
  text-align: end;
  align-items: flex-end;
  min-height: 40px;
  border-left: 1px solid #777777;
`

export const ExtraServiceImportant = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${props => props.theme.colors.black};
  margin-top: 10px;
  white-space: pre-line;
  text-align: left;
`
